<template>
    <div class="bg-box">
        <div class="main-box" v-if="currentGame.appStoreGameName">
            <div class="title">Delete Account</div>
            <el-row class="game-info">
                <el-col :span="18">
                    <div class="game-name">{{ currentGame.appStoreGameName }}</div>
                    <div>{{ currentGame.developerName }}</div>
                </el-col>
                <el-col :span="6">
                    <div class="logo">
                        <el-image :src="currentGame.gameLogoLink"></el-image>
                    </div>
                </el-col>
            </el-row>
            <div class="mt-20">Dear User,</div>
            <div class="mt-20">In accordance with relevant laws and regulations, you have the right to request the deletion
                of your
                account. Please note that once your account is deleted, all information and data associated with the account
                will be permanently deleted and cannot be recovered. This includes but is not limited to your personal
                information, game progress, purchase records, etc. Therefore, please carefully consider your decision before
                submitting a deletion request.</div>
            <div class="mt-20 mb-10">Please fill in your user information:</div>
            <el-form label-position="top" :model="form" :rules="rules" ref="ruleForm" :show-message="false"
                :hide-required-asterisk="true" size="mini">
                <el-form-item prop="user_name">
                    <template v-slot:label>
                        Username<span class="red-asterisk">*</span>
                    </template>
                    <el-input v-model="form.user_name" maxlength="200"></el-input>
                </el-form-item>
                <el-form-item prop="email_address">
                    <template v-slot:label>
                        Email Address<span class="red-asterisk">*</span>
                    </template>
                    <el-input v-model="form.email_address" maxlength="200"></el-input>
                </el-form-item>
                <el-form-item prop="account_id">
                    <template v-slot:label>
                        Account ID<span class="red-asterisk">*</span>
                    </template>
                    <el-input v-model="form.account_id" maxlength="200"></el-input>
                </el-form-item>
                <div class="mb-10">To verify your identity and ensure the security of your account, we require some
                    additional
                    information:</div>
                <el-form-item prop="login_method" label="Login Method (used during registration)">
                    <el-input v-model="form.login_method" maxlength="200"></el-input>
                </el-form-item>
                <el-form-item prop="past_google_orders" label="Past Google Orders (if any)">
                    <el-input v-model="form.past_google_orders" maxlength="200"></el-input>
                </el-form-item>
                <el-form-item prop="any_additional_information" label="Any Additional Information">
                    <el-input v-model="form.any_additional_information" maxlength="200"></el-input>
                </el-form-item>
            </el-form>
            <div class="mt-30">Please refer to our <el-link href="https://bettagames.com/privacy" type="primary"
                    :underline="false" style="vertical-align: baseline;">Privacy Policy</el-link> and <el-link
                    href="https://bettagames.com/terms" type="primary" :underline="false"
                    style="vertical-align: baseline;">Terms of Service</el-link> for more information on how we handle your
                personal
                data and the rules governing our services. By submitting this account deletion request, you confirm that you
                have read and agreed to these terms.</div>
            <div class="submit"><el-button @click="submit('ruleForm')" type="primary" size="medium">Submit</el-button></div>
        </div>
    </div>
</template>

<script>
import gameList from "./gamesList.js";

export default {
    data() {
        return {
            form: {
                app_id: Number(this.$route.params.appId),
                user_name: '',
                email_address: '',
                account_id: '',
                login_method: '',
                past_google_orders: '',
                any_additional_information: '',
            },
            rules: {
                user_name: [
                    { required: true, trigger: 'change' }
                ],
                email_address: [
                    { required: true, trigger: 'change' }
                ],
                account_id: [
                    { required: true, trigger: 'change' }
                ],
            }
        }
    },
    computed: {
        currentGame() {
            return gameList[this.$route.params.appId] ? gameList[this.$route.params.appId] : {}
        }
    },
    methods: {
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    fetch("https://console.bettagames.com/bi-console/google-delete-account/submit", {
                        method: 'POST',
                        headers: {
                            "content-type": "application/json"
                        },
                        body: JSON.stringify(this.form)
                    }).then(res => {
                        return res.json()
                    }).then(data => {
                        if (data.code === 0) {
                            this.$message({
                                message: 'Submitted successfully',
                                type: 'success',
                                duration: 0,
                                showClose: true,
                            });
                            this.$refs[formName].resetFields()
                        }
                    }).catch(err => {
                        this.$message.error('error submit!!');
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}

</script>

<style scoped lang="less">
.bg-box {
    background-color: #fff;
    width: 100%;
    text-align: left;
    min-height: 100vh;
    font-size: 14px;
}

.main-box {
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 10px;

    .title {
        font-size: 20px;
        font-weight: bold;
        width: 100%;
        text-align: center;
        padding-top: 20px;
    }

    .game-info {
        margin-top: 20px;

        .game-name {
            font-size: 24px;
            font-weight: bold;
        }

        .logo {
            width: 60px;
            height: 60px;
            float: right;
            border-radius: 8px;
            overflow: hidden;
        }
    }
}

.red-asterisk {
    font-size: 20px;
    color: #F56C6C;
    margin-left: 10px;
    vertical-align: middle;
}

.submit {
    text-align: center;
    padding: 40px 0;
}

.mt-20 {
    margin-top: 20px;
}

.mt-30 {
    margin-top: 30px;
}

.mb-10 {
    margin-bottom: 10px;
}
</style>
<style lang="less">
.bg-box {
    .el-form--label-top .el-form-item__label {
        padding: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/deleteAccount/index.vue